import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import LineQualityDataEditDialog from '../../Dialogs/Configuration/LineQualityDataEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function LineQualityDataTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(true);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getLineQualityData = async function () {
            let url = `api/v1/linequalitydata/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getLineQualityData();
    }, [includeDeleted, refresh, fetchDataAuthenticated]);

    const tableColumns = [
        {
            Header: 'Line',
            accessor: 'lineName',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>);
            }
        },
        {
            Header: 'Quality',
            accessor: 'qualityName',
            filter: 'includesString'
        },
        {
            Header: 'Value To Use',
            accessor: 'defaultValueToUse',
            filter: 'includesString'
        },
        {
            Header: 'Transfer Calc',
            accessor: 'transferCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Transfer Offspec?',
            accessor: 'transferIsOffspecFunction',
            filter: 'includesString'
        },
        {
            Header: 'Batch Calc',
            accessor: 'batchCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Batch Lab Calc',
            accessor: 'batchLabCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Batch Offspec?',
            accessor: 'batchIsOffspecFunction',
            filter: 'includesString'
        },
        {
            Header: 'Lot Calc',
            accessor: 'lotCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Lot Lab Calc',
            accessor: 'lotLabCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'Lot Offspec?',
            accessor: 'lotIsOffspecFunction',
            filter: 'includesString'
        },
        {
            Header: 'PO Lot Calc',
            accessor: 'packoutLotCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'PO Lot Lab Calc',
            accessor: 'packoutLotLabCalculateFunction',
            filter: 'includesString'
        },
        {
            Header: 'PO Lot Offspec?',
            accessor: 'packoutLotIsOffspecFunction',
            filter: 'includesString'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    return (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} initialState={{}} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );
}

function LineQualityDataConfiguration() {

    const { businessUnits } = useBusinessUnits(false);

    return (
        <CommonConfigPage
            title="Line Quality Data"
            Table={LineQualityDataTable}
            Dialog={LineQualityDataEditDialog}
            businessUnits={businessUnits}
        />
    );
}

export default LineQualityDataConfiguration;